module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("For making a stranger feel a little less alien in a strange land, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Covenant Rising")]), _vm._v(" is dedicated to the Brum Balti Boyz – Mike Chinn, Peter Coleborn, John Howard, Joel Lane, David Sutton; and to the Gurlz – Jan Edwards, Sue Edwards, Sandra Sutton. And, of course, to my wife, Anne.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb4c34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 63
// module chunks = 0